import { render, staticRenderFns } from "./SalaryDayReport.vue?vue&type=template&id=70e19c74&"
import script from "./SalaryDayReport.vue?vue&type=script&lang=js&"
export * from "./SalaryDayReport.vue?vue&type=script&lang=js&"
import style0 from "./SalaryDayReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports